import { Icon, type IconProps } from "@chakra-ui/react";

const MoonSteroidIcon = (props: IconProps) => {
	return (
		<Icon
			viewBox="0 0 38 38"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g opacity="0.3">
				<rect
					x="6"
					y="6"
					width="26"
					height="26"
					rx="13"
					stroke="currentColor"
					strokeWidth="2"
				/>
			</g>
			<g opacity="0.1">
				<rect
					x="1"
					y="1"
					width="36"
					height="36"
					rx="18"
					stroke="currentColor"
					strokeWidth="2"
				/>
			</g>
			<g clipPath="url(#clip0_5700_5485)">
				<path
					d="M27.2955 19.7972C26.1481 21.81 23.9825 23.167 21.4998 23.167C17.8179 23.167 14.8332 20.1822 14.8332 16.5003C14.8332 14.0175 16.1904 11.8517 18.2034 10.7043C13.9746 11.1053 10.6665 14.6664 10.6665 19.0001C10.6665 23.6025 14.3975 27.3334 18.9998 27.3334C23.3333 27.3334 26.8943 24.0257 27.2955 19.7972Z"
					stroke="currentColor"
					strokeWidth="1.66667"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_5700_5485">
					<rect
						width="20"
						height="20"
						fill="white"
						transform="translate(9 9)"
					/>
				</clipPath>
			</defs>
		</Icon>
	);
};

export default MoonSteroidIcon;
